<template>
  <v-container fluid v-if="authenticated">
   <div v-if="authenticated">
    <v-layout align-start wrap justify-start>
      <v-flex xs12>
          <span class="dHeading">Re:Monitoring</span>
          <div>
            <KilnSelect allowall="true" btnlabel="all" complabel="Monitor" v-on:window-closed="doSubscription()"></KilnSelect>
            <v-btn icon @click="doSubscription()"><v-icon>refresh</v-icon></v-btn> <span v-if="socketConnected">CONNECTED</span><span v-else>DISCONNECTED</span>
          </div>
      </v-flex>
            <TemperatureGauge
                v-for="(temp) in temperatures"
                v-bind:chartData="temp"
                v-bind:key="temp.rows[0].id"></TemperatureGauge>
            <v-snackbar v-model="snackbar" :bottom="y === 'bottom'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
                :right="x === 'right'" :timeout="timeout" :top="y === 'top'" :vertical="mode === 'vertical'" color='warning'>
                {{ text }}
                <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import KilnSelect from '../components/KilnSelectComponent'
import TemperatureGauge from '../components/TemperatureGauge'
import { format } from 'date-fns'

export default {
    data() {
        return {
            snackbar: false,
            y: 'top',
            x: 'left',
            mode: '',
            timeout: 4000,
            text: '',
            temperatures: []
        }
    },
    components: {
        KilnSelect,
        TemperatureGauge
    },
    methods: {
        ...mapGetters([
            'getLoggedInUser',
            'getSocketConnected',
            'getSelectedLocation',
            'getSelectedKiln',
            'getUserPassword',
            'getSessionId'
        ]),
        ...mapMutations([
            'setSessionId',
            'setSocketConnected'
        ]),
        getTimestamp() {
            return( format(new Date(), 'YYYY-MM-DD HH:mm:ss') );
        },
        doSubscription() {
            if ( this.getSocketConnected() === false ) {
                this.$connect();
                this.setSocketConnected( true );
                this.label = "Monitoring";
            } else {
                this.sendSubscription();
            }
        },
        sendSubscription() {
            var payload = {messageType: 'subRequest', sessionId: this.getSessionId(), accountId: this.getLoggedInUser().accountId, location: this.getSelectedLocation().name, kilnId: this.getSelectedKiln().name}
            this.$socket.sendObj( payload )
        },
        findIndex( id ) {
            var idx = -1;
    
            for ( var i = 0; i < this.temperatures.length; i++ )
            {
                if ( this.temperatures[i].rows[0].id == id )
                {
                    idx = i;
                    break;
                }
            }

            return( idx );
        },
        updateTemperature( msgObj ) {
            var marker = msgObj.location + '/' + msgObj.kilnId + '/' + msgObj.tcId;
            var idx = this.findIndex( marker );

            if ( idx < 0 )
            {
                var tempObj = '{"columns": ["id", "temperature", "junctionTemp"], "rows":[{"id":"' + marker + '", "temperature":' + msgObj.tcTemperature + ', "tcId":"' + msgObj.tcId + '", "location":"' + msgObj.location + '", "kilnId":"' + msgObj.kilnId + '", "junctionTemp":' + msgObj.intTemperature + ', "fault":"' + msgObj.fault + '", "faultType":"' + msgObj.faultType + '", "updated":"' + this.getTimestamp() + '"}]}';
                var obj = JSON.parse( tempObj );
                this.temperatures.push( obj );
            }
            else
            {
                this.temperatures[idx].rows[0].temperature  = msgObj.tcTemperature;
                this.temperatures[idx].rows[0].junctionTemp = msgObj.intTemperature;
                this.temperatures[idx].rows[0].updated      = this.getTimestamp();
            }
        }
    },
    computed: {
        ...mapState([
            'authenticated',
            'socketConnected'
        ])
    },
    mounted() {
        this.$options.sockets.onmessage = (message) => {
            var msgObj = JSON.parse( message.data );
            var msgType = msgObj.messageType;
            var payload;
            switch( msgType )
            {
                case 'authChallenge':
                    payload = {messageType: 'authRequest', email: this.getLoggedInUser().email, password: this.getUserPassword()}
                    this.$socket.sendObj( payload )
                    break;

                case 'authResponse':
                    if ( msgObj.authenticated == true ) {
                        this.setSessionId( msgObj.sessionId );
                        var payload = {messageType: 'subRequest', sessionId: this.getSessionId(), accountId: this.getLoggedInUser().accountId, location: this.getSelectedLocation().name, kilnId: this.getSelectedKiln().name}
                        this.$socket.sendObj( payload )
                    }
                    break;

                case 'subResponse':
                    if ( msgObj.succeeded == false )
                    {
                        this.setSessionId( -1 );
                        this.text = 'Error subscribing to kiln data updates'
                        this.snackbar = true;
                    }
                    break;

                case 'tcUpdate':
                    this.updateTemperature( msgObj );
                    break;
            }
        }
    }
  }
</script>

<style scoped>
.dHeading {
    font-size: 20px;
    font-weight: bold
}
</style>